/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCustomerCreditsService() {
        let customerCreditsService = {};
        customerCreditsService.loadCompanyCredits = function (request){
            return axios.post("/api/CustomerCreditsService/LoadCompanyCredits", request);
        };
        customerCreditsService.reduceCompanyCredits = function (request){
            return axios.post("/api/CustomerCreditsService/ReduceCompanyCredits", request);
        };
        customerCreditsService.getCompanyCreditHistoryByCompany = function (request){
            return axios.post("/api/CustomerCreditsService/GetCompanyCreditHistoryByCompany", request);
        };
        customerCreditsService.getCurrentCompanyCreditByCompany = function (companyId){
            return axios.get("/api/CustomerCreditsService/GetCurrentCompanyCreditByCompany?companyId=" + companyId);
        };
        customerCreditsService.addOrUpdateBulkCreditsTopUps = function (request){
            return axios.post("/api/CustomerCreditsService/AddOrUpdateBulkCreditsTopUps", request, { headers: {'Content-Type': 'multipart/form-data' }});
        };
        customerCreditsService.topUpCreditsInBulk = function (request){
            return axios.post("/api/CustomerCreditsService/TopUpCreditsInBulk", request);
        };
        customerCreditsService.getCompanyCreditAccounts = function (request){
            return axios.post("/api/CustomerCreditsService/GetCompanyCreditAccounts", request);
        };
        customerCreditsService.downloadCompanyCreditAccounts = function (request){
            return axios.post("/api/CustomerCreditsService/DownloadCompanyCreditAccounts", request, { responseType: 'blob' });
        };
        return customerCreditsService;
    }
    //define globally if it doesn't already exist
    if (typeof (customerCreditsService) === "undefined") {
        window.customerCreditsService = defineCustomerCreditsService();
    } else {
        console.log("customerCreditsService already defined.");
    }
})(window);